import React, { useState } from 'react';
import { Lock } from 'lucide-react'; // Using lucide-react consistent with your other files
import UpgradeModal from './UpgradeModal'; // <--- This import should now work

const FeatureGuard = ({ 
    isSubscribed, 
    children, 
    featureName = "Premium Feature", 
    benefitText = "Unlock this feature to grow your business faster."
}) => {
    const [showModal, setShowModal] = useState(false);

    // If subscribed, just render the button/feature normally
    if (isSubscribed) {
        return children;
    }

    // If NOT subscribed, intercept the click
    const handleLockClick = (e) => {
        // Prevent parent buttons from firing
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    return (
        <>
            <div 
                onClick={handleLockClick} 
                style={{ position: 'relative', display: 'inline-block', cursor: 'pointer', width: '100%' }}
                title={`Locked: ${featureName}`}
            >
                {/* 1. The content (dimmed slightly) */}
                <div style={{ pointerEvents: 'none', opacity: 0.75, filter: 'grayscale(0.3)' }}>
                    {children}
                </div>
                
                {/* 2. The Lock Overlay Badge */}
                <div style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    background: 'linear-gradient(135deg, #fbbf24 0%, #d97706 100%)', // Gold gradient
                    color: '#fff',
                    borderRadius: '50%',
                    width: '22px',
                    height: '22px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    zIndex: 10,
                    border: '1px solid white'
                }}>
                    <Lock size={12} />
                </div>
            </div>

            {/* 3. The Diplomatic Modal */}
            {showModal && (
                <UpgradeModal 
                    title={`Unlock ${featureName}`}
                    message={benefitText}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};

export default FeatureGuard;